import { createFileRoute } from '@tanstack/react-router';

interface NewSigningRequestSearch {
  employeeId?: string;
}

export const Route = createFileRoute('/w/signing-requests/new')({
  staticData: {
    hideShell: true,
    breadcrumb: 'New Signing Request',
    breadcrumbKey: 'K_BREADCRUMB_NEW_SIGNING_REQUEST',
  },
  validateSearch: (search: Record<string, unknown>): NewSigningRequestSearch => ({
    employeeId: typeof search.employeeId === 'string' ? search.employeeId : undefined,
  }),
});
